import React, {Fragment} from "react";
import {connect} from "react-redux";
import {updatePage} from "../../actions/page";
import {Button, Col, Form, Input, InputNumber, Row, Select, message, Card, Alert} from "antd";
import FirewallRuleCondition from "../../components/firewall/FirewallRuleCondition";
import {createFirewallRule, editFirewallRule, loadFirewallRule, loadPredefinedBots} from "../../actions/firewall";
import {displayErrors, isNumeric} from "../../libs/utils";
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined";
import countryList from "react-select-country-list";
import {Loading} from "../../libs/loading";
import AccessItem from "../../components/permissions/AccessItem";

class FirewallRuleDetail extends React.Component {
    state = {
        name: '',
        rule: {
            type: 'FIREWALL',
            conditions: [
                [ { field: 'http.request.uri', operator: 'EQUALS', value: '' } ]
            ],
            action: {
                type: 'REJECT',
                default_type: 'ALLOW',
                redirect_destination: null,
                redirect_status_code: null
            },
            max_requests: 150,
            time_frame: 'MINUTE'
        },
        priority: 0,
        random: Date.now(),
        loading: false,
        action: 'ADDING',
        ruleLoaded: false
    };

    blockDuration = [
        { label: 'Second', value: 'SECOND' },
        { label: 'Minute', value: 'MINUTE' },
    ]

    countries = countryList().getData();

    predefinedBots = [];

    componentDidMount() {
        if(typeof this.props.match.params.guid !== 'undefined') {
            this.setState({ action: 'EDITING', activeRule: this.props.match.params.guid });
            this.props.updatePage('Edit Firewall Rule');

            this.props.loadFirewallRule(this.props.match.params.guid, (res) => {
                this.setState({ ruleLoaded: true, name: res.data.name, priority: res.data.priority, rule: res.data.data });
            }, (err) => {
                if(typeof err.response !== 'undefined') {
                    displayErrors(err.response.data);
                }
            });
        } else {
            this.props.updatePage('Add Firewall Rule');
        }

        this.props.loadPredefinedBots((res) => {
            this.predefinedBots = res.data.map((bot) => {
                return { label: bot.name, value: bot.value };
            });
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
            }
        });
    }

    updateRuleDetail(field, value) {
        let rule = this.state.rule;
        rule[field] = value;

        this.setState({ rule });
    }

    updateRuleAction(field, value) {
        let rule = this.state.rule;
        let action = rule.action;

        if(field === 'default_type') {
            action['default_type'] = value;

            if(value === 'REJECT') {
                action['type'] = 'ALLOW';
            } else if(value === 'ALLOW') {
                action['type'] = 'REJECT';
            }
        }

        if(field === 'type') {
            action['type'] = value;

            if(value === 'REJECT') {
                action['default_type'] = 'ALLOW';
            } else if(value === 'ALLOW') {
                action['default_type'] = 'REJECT';
            } else if(value === 'REDIRECT') {
                action['default_type'] = 'ALLOW';
            }
        }

        if(field === 'redirect_destination') {
            action['redirect_destination'] = value;
        } else if(field === 'redirect_status_code') {
            action['redirect_status_code'] = parseInt(value);
        }

        if(action['type'] !== 'REDIRECT' && action['default_type'] !== 'REDIRECT') {
            delete action['redirect_destination'];
            delete action['redirect_status_code'];
        }

        rule.action = action;

        this.setState({ rule });
    }

    updateCondition(condition_block_index, condition_index, data) {
        let rule = this.state.rule;

        rule.conditions = rule.conditions.map((condition_block, _condition_block_index) => {
            if(_condition_block_index === condition_block_index) {
                return condition_block.map((condition, _condition_index) => {
                    if(_condition_index === condition_index) {
                        return data;
                    }

                    return condition;
                });
            }

            return condition_block;
        });

        this.setState({ rule });
    }

    addAndCondition() {
        let rule = this.state.rule;
        rule.conditions.push([ { field: 'http.request.uri', operator: 'EQUALS', value: '' } ]);
        this.setState({ rule });
    }

    addOrCondition(conditionAndBlockIndex) {
        let rule = this.state.rule;

        rule.conditions = rule.conditions.map((condition_block, _condition_block_index) => {
            if(_condition_block_index === conditionAndBlockIndex) {
                condition_block.push({ field: 'http.request.uri', operator: 'EQUALS', value: '' });
                return condition_block;
            }

            return condition_block;
        });

        this.setState({ rule });
    }

    removeCondition(conditionAndBlockIndex, conditionIndex) {
        let rule = this.state.rule;

        let conditionsBlock = [];

        for(let i = 0; i < this.state.rule.conditions.length; i++) {
            if(conditionAndBlockIndex === i) {
                let conditionsList = [];

                for(let j = 0; j < this.state.rule.conditions[i].length; j++) {
                    if(conditionIndex !== j) {
                        conditionsList.push(this.state.rule.conditions[i][j]);
                    }
                }

                if(conditionsList.length > 0) {
                    conditionsBlock.push(conditionsList);
                }
            } else {
                conditionsBlock.push(this.state.rule.conditions[i]);
            }
        }

        rule.conditions = conditionsBlock;

        this.setState({ rule, random: Date.now() });
    }

    updateRule() {
        let name = this.state.name.trim();
        let priority = this.state.priority;

        if(name === '') {
            return message.error('Please enter a name for your rule!');
        }

        if(!isNumeric(priority)) {
            return message.error('Priority must be a number between 0 and 9999!');
        }

        if(priority < 0 || priority > 9999) {
            return message.error('Priority must be between 0 and 9999!');
        }

        if(this.state.rule.conditions.length === 0) {
            return message.error('Please enter at least 1 condition!');
        }

        if(this.state.rule.type === 'RATE_LIMIT' && this.state.rule.max_requests < 1) {
            return message.error('Maximum number of requests must be a positive number!');
        }

        let rule = this.state.rule;

        if(rule.type === 'FIREWALL') {
            delete rule.max_requests;
            delete rule.time_frame;
        }

        let data = {
            name: name,
            priority: priority,
            rule: this.state.rule
        };

        if(this.state.rule.action.type === 'REDIRECT' || this.state.rule.action.default_type === 'REDIRECT') {
            let destination = this.state.rule.action.redirect_destination;

            if(typeof destination === 'undefined' || destination === null || destination.trim() === '') {
                return message.error('Please enter the redirect destination!');
            }

            if(!destination.startsWith('http://') && !destination.startsWith('https://')) {
                return message.error('The redirect destination must start with http(s)://!');
            }

            let status_code = this.state.rule.action.redirect_status_code;

            if(typeof status_code === 'undefined' || status_code === null || status_code === '') {
                return message.error('Please enter the redirect status code!');
            }

            if(![301, 302, 303, 307, 308].includes(status_code)) {
                return message.error('Invalid redirect status code!');
            }
        }

        this.setState({ loading: true });

        if(this.state.action === 'EDITING') {
            this.props.editFirewallRule(this.state.activeRule, data, () => {
                this.setState({ loading: false });
                message.success('Firewall rule successfully updated!');
                this.props.history.push('/firewall');
            }, (err) => {
                if(typeof err.response !== 'undefined') {
                    this.setState({ loading: false });
                    displayErrors(err.response.data);
                }
            });
        } else {
            this.props.createFirewallRule(data, () => {
                this.setState({ loading: false });
                message.success('Firewall rule successfully created!');
                this.props.history.push('/firewall');
            }, (err) => {
                if(typeof err.response !== 'undefined') {
                    this.setState({ loading: false });
                    displayErrors(err.response.data);
                }
            });
        }
    }

    render() {
        const { Option } = Select;

        if(this.state.action === 'EDITING' && !this.state.ruleLoaded) {
            return <div className='text-center'><Loading /></div>;
        }

        let andBlockCount = this.state.rule.conditions.length;

        let conditions = this.state.rule.conditions.map((conditionAndBlock, conditionAndBlockIndex) => {
            let orBlockCount = conditionAndBlock.length;
            let orBlocks = conditionAndBlock.map((condition, conditionIndex) => {
                return <Fragment key={conditionIndex + this.state.random}>
                    <div className='logic-block or'>
                        <Row key={conditionIndex + this.state.random}>
                            <Col span={20}>
                                <FirewallRuleCondition
                                    countries={this.countries}
                                    predefinedBots={this.predefinedBots}
                                    key={conditionIndex}
                                    condition={condition}
                                    onChange={(data) => this.updateCondition(conditionAndBlockIndex, conditionIndex, data)} />
                            </Col>
                            <Col flex="auto" align='right'>
                                <Button.Group>
                                    {(conditionAndBlockIndex + 1) === andBlockCount ? <Button onClick={() => this.addAndCondition()}>AND</Button> : ''}
                                    <Button onClick={() => this.addOrCondition(conditionAndBlockIndex, conditionIndex)}>OR</Button>
                                    <Button disabled={orBlockCount === 1 && andBlockCount === 1} onClick={() => this.removeCondition(conditionAndBlockIndex, conditionIndex)} icon={<DeleteOutlined />} />
                                </Button.Group>
                            </Col>
                        </Row>
                    </div>
                    { (conditionIndex + 1) < orBlockCount ? <div className='logic-block-separator or'><span>OR</span></div> : ''}
                </Fragment>
            });

            return <Fragment key={conditionAndBlockIndex}>
                <div className='logic-block and'>{orBlocks}</div>
                { (conditionAndBlockIndex + 1) < andBlockCount ? <div className='logic-block-separator and'><span>AND</span></div> : '' }
            </Fragment>;
        });

        return(
            <Card size='small'>
                <Form layout='vertical'>
                    <Form.Item label='Name'>
                        <Input value={this.state.name} onChange={(e) => this.setState({ name: e.target.value})} />
                    </Form.Item>
                    <Form.Item label='Type'>
                        <Select value={this.state.rule.type} onChange={(value) => this.updateRuleDetail('type', value)}>
                            <Option value='FIREWALL'>Firewall</Option>
                            <Option value='RATE_LIMIT'>Rate limit</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label='Priority' extra={<small>Priority sets the order of which firewall rules are executed.</small>}>
                        <InputNumber min={0} maxLength={9999} value={this.state.priority} onChange={(value) => this.setState({ priority: value })} />
                    </Form.Item>
                    <Form.Item label='Conditions'>
                        <Card className='conditions'>
                            {conditions}
                        </Card>
                    </Form.Item>
                    <Form.Item label='Action' extra={<small>Action that will be taken when condition matches the request.</small>}>
                        <Select value={this.state.rule.action.type} onChange={(value) => this.updateRuleAction('type', value)}>
                            <Option value='REJECT'>Reject</Option>
                            <Option value='ALLOW'>Allow</Option>
                            <Option value='REDIRECT'>Redirect</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label='Default action' extra={<small>Action that will be taken if the condition does not match the request.</small>}>
                        <Select value={this.state.rule.action.default_type} onChange={(value) => this.updateRuleAction('default_type', value)}>
                            <Option value='REJECT'>Reject</Option>
                            <Option value='ALLOW'>Allow</Option>
                        </Select>
                        {this.state.rule.action.default_type === 'REJECT' ? <Alert style={{marginTop: '10px'}} type='warning' showIcon message='Attention!' description='Default action is set to reject! Ensure your rule is set up as intended. Rejecting requests by default can cause loss of rankings and issues with indexing and more!' /> : ''}
                    </Form.Item>
                    <Form.Item hidden={this.state.rule.action.type !== 'REDIRECT' && this.state.rule.action.default_type !== 'REDIRECT'} label='Redirect destination' extra={<small>The URL where the visitor is redirected.</small>}>
                        <Input value={this.state.rule.action.redirect_destination} onChange={(e) => this.updateRuleAction('redirect_destination', e.target.value.trim())} />
                    </Form.Item>
                    <Form.Item hidden={this.state.rule.action.type !== 'REDIRECT' && this.state.rule.action.default_type !== 'REDIRECT'} label='Redirect status code' extra={<small>The status code that's returned for the redirect.</small>}>
                        <Select value={this.state.rule.action.redirect_status_code} onChange={(value) => this.updateRuleAction('redirect_status_code', value)}>
                            <Option value={301}>301 Moved Permanently</Option>
                            <Option value={302}>302 Found (Previously "Moved Temporarily")</Option>
                            <Option value={303}>303 See Other</Option>
                            <Option value={307}>307 Temporary Redirect</Option>
                            <Option value={308}>308 Permanent Redirect</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item hidden={this.state.rule.type !== 'RATE_LIMIT'} label='Requests per time frame:'>
                        <Row gutter={[16, 16]}>
                            <Col>
                                <InputNumber value={this.state.rule.max_requests} min={0} onChange={(value) => this.updateRuleDetail('max_requests', value)} />
                            </Col>
                            <Col>
                                <Select options={this.blockDuration}
                                        style={{width: '100px'}}
                                        value={this.state.rule.time_frame}
                                        onChange={(value) => this.updateRuleDetail('time_frame', value)} />
                            </Col>
                        </Row>
                    </Form.Item>
                    <AccessItem scopes={['can_add_firewall_rules', 'can_edit_firewall_rules']}>
                        <Form.Item>
                            <Button type='primary' loading={this.state.loading} disabled={this.state.loading} onClick={() => this.updateRule()}>{this.state.action === 'EDITING' ? 'Update Firewall Rule' : 'Create Firewall Rule'}</Button>
                        </Form.Item>
                    </AccessItem>
                </Form>
            </Card>
        );
    }
}

export default connect(null, { updatePage, loadPredefinedBots, createFirewallRule,
    loadFirewallRule, editFirewallRule })(FirewallRuleDetail);